import {AlertSizes, AlertTypes} from "../Alert";

const alertColors = {
  success: {
    backgroundColor: '#5cb85c',
    borderColor: '#4cae4c'
  },
  warning: {
    backgroundColor: '#f0ad4e',
    borderColor: '#eea236'
  },
  danger: {
    backgroundColor: '#d9534f',
    borderColor: '#d43f3a'
  },
  info: {
    backgroundColor: '#319bd5',
    borderColor: '#247eaf',
  }
};

export const containerStyles = {
  display: 'block'
};

export const alertStyles = (props) => {
  let backgroundColor;
  let borderColor;
  let width;
  let marginTop;
  let float;

  if(props && props.type) {
    switch(props.type) {
      case AlertTypes.WARNING:
        backgroundColor = alertColors.warning.backgroundColor;
        borderColor = alertColors.warning.borderColor;
        break;
      case AlertTypes.DANGER:
        backgroundColor = alertColors.danger.backgroundColor;
        borderColor = alertColors.danger.borderColor;
        break;
      case AlertTypes.SUCCESS:
        backgroundColor = alertColors.success.backgroundColor;
        borderColor = alertColors.success.borderColor;
        break;
      default:
        backgroundColor = alertColors.info.backgroundColor;
        borderColor = alertColors.info.borderColor
    }
  }
  if(props && props.size != null) {
    switch(props.size) {
      case AlertSizes.LARGE:
        width = "75vw";
        marginTop = "8vh";
        float = "none";
        break;
      case AlertSizes.SMALL:
      default:
        width = "30vw";
        marginTop= "6vh";
        float = "right";
        break;
    }
  }

  return {
    opacity: '1',
    zIndex: '9999',
    marginTop,
    backgroundColor,
    borderColor,
    borderRadius: '0',
    borderLeftWidth: '3px',
    borderLeftStyle:'solid',
    color: '#FFFFFF',
    fontFamily: 'sans-serif',
    padding: '1em',
    float,
    width
  }
};

export const closeIconStyles = {
  cursor: 'pointer',
  opacity: '.5',
  fontSize: '20px',
  marginTop: '.18em'
};

export const alertIconStyles = {
  display: 'block',
  float:'left',
  marginRight:'.8em'
};

export const headingStyles = {
  fontWeight: '500',
  fontSize: '12px'
};

export const contentStyles = {
  fontWeight: '300',
  lineHeight: '1.25rem',
  fontSize:'14px',
  paddingLeft: '.3em'
};
